import { CanvasWrapDisableWH, CanvasWrapEnableWH } from "./canvas-wrap";

export function getMiniAppCanvasOptions(params, pixelRatio, offscreen = null == params.id) {
    var _a, _b, _c;
    return {
        id: null == params.id ? void 0 : String(params.id),
        width: null !== (_a = params.width) && void 0 !== _a ? _a : 0,
        height: null !== (_b = params.height) && void 0 !== _b ? _b : 0,
        dpr: null !== (_c = params.dpr) && void 0 !== _c ? _c : pixelRatio,
        offscreen: offscreen
    };
}

export function wrapMiniAppNativeCanvas(nativeCanvas, options) {
    var _a;
    const ctx = null === (_a = null == nativeCanvas ? void 0 : nativeCanvas.getContext) || void 0 === _a ? void 0 : _a.call(nativeCanvas, "2d");
    if (!ctx) throw new Error('MiniApp canvas bridge returned a canvas without getContext("2d").');
    return new CanvasWrapEnableWH(nativeCanvas, ctx, options.dpr, options.width, options.height, options.id);
}

export function wrapMiniAppContextCanvas(ctx, options) {
    if (!ctx) throw new Error("MiniApp canvas bridge returned an empty 2d context.");
    const canvas = new CanvasWrapDisableWH(ctx.canvas || {}, ctx, options.dpr, options.width, options.height, options.id);
    return ctx.canvas = canvas, canvas;
}

export function createCanvasWithFactory(params, pixelRatio, canvasMap, factory) {
    const options = getMiniAppCanvasOptions(params, pixelRatio), id = options.id;
    if (null != id) {
        const existing = canvasMap.get(id);
        if (existing) return existing;
    }
    if (!factory) return null;
    const canvas = wrapMiniAppNativeCanvas(factory(options), options);
    return null != id && canvasMap.set(id, canvas), canvas;
}
//# sourceMappingURL=miniapp-canvas.js.map
